'use client';
import Col from "./Col.js";
export default Col;